import React, {Component} from 'react';
import { withRouter } from 'react-router-dom'
import SearchApi from "../../api/SearchApi";
import AutocompleteList from "./AutocompleteList";
import Icon from "../Icon";

const axios = require("axios");

class SearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: null,
      autocomplete: [],
      opened: false
    };

    this.onBodyClick = this.onBodyClick.bind(this);
  }

  componentDidMount() {
    let params = new URLSearchParams(this.props.location.search);
    let query = params.get("query");
    if (query) {
      this.setState({
        query: query
      })
    }

    window.addEventListener('click', this.onBodyClick)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      let params = new URLSearchParams(this.props.location.search);

      this._input.value = params.get("query");
      this.setState({ query: params.get("query"), autocomplete: [], opened: false });

      if (this._signal) {
        this._signal.cancel();
      }

      this.onClose();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onBodyClick)
  }

  onChange(e) {
    let value = e.currentTarget.value;

    clearTimeout(this._timeout);
    this._timeout = setTimeout(() => {
      this.loadSuggestions(value);
    }, 400);
  }

  onSearchSubmit(e) {
    e.preventDefault();

    this.props.history.push("/search?query=" + this._input.value);

    return false;
  }

  onClose() {
    this.setState({
      opened: false
    })
  }

  onBodyClick(e) {
    if (e.target.closest(".search-bar")) {
      return;
    }

    this.setState({ opened: false });
  }

  loadSuggestions(value) {
    if (value.length > 2) {
      if (this._signal) {
        this._signal.cancel();
      }

      this._signal = axios.CancelToken.source();

      this.setState({ opened: true }, () => {
        SearchApi.autocomplete(value, { limit: 5 }, { cancelToken: this._signal.token }).then(res => {
          this.setState({
            autocomplete: res.data.data
          })
        }).catch(e => {

        });
      })
    }
  }

  render() {
    const { query } = this.state;

    return (
      <div className={'search-bar'}>
        <form onSubmit={this.onSearchSubmit.bind(this)}>
          <input ref={e => this._input = e} type={'text'} className={'form-control'} name={'query'} onChange={this.onChange.bind(this)} defaultValue={query} autoComplete={"off"} />
          <button><Icon icon={'search'} /></button>
        </form>
        {this.state.opened && <AutocompleteList list={this.state.autocomplete} callback={this.onClose.bind(this)} />}
      </div>
    );
  }
}

export default withRouter(SearchBar);